import m from "../../geodata/es2015/yemenLow";
window.am4geodata_yemenLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/yemenLow.js
// module id = null
// module chunks = 